import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../stili/Popup.css';

export default function TimedPopup({ message, duration = 5000 }) {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => navigate('/gestionale', { replace: true }), duration);
    return () => clearTimeout(timer);
  }, [navigate, duration]);

  return (
    <div className="popup-overlay">
      <div className="popup">
        <h2>⛔ Accesso Negato</h2>
        <p>{message}</p>
      </div>
    </div>
  );
}
